

export var schema = {
  title: "Geyser",
  description: "Geyser form",
  type: "object",
  properties: {
    broker: {
      type: "object",
      title: "Broker",
      required: ["insuredName", "insuredPolicyNumber", "brokertel", "brokeremail"],
      properties: {
        brokertel: {
          type: "string",
          title: "Telephone Number",
          minLength: 10
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        },
        insuredName: {
          type: "string",
          title: "Name of Insured"
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        }
      }
    },
    insured: {
      type: "object",
      title: "Insured",
      properties: {
        insuredtel: {
          type: "string",
          title: "Telephone Number",
          minLength: 10
        },
        insuredcell: {
          type: "string",
          title: "Cell Number",
          minLength: 10
        },
        insuredaddress: {
          type: "string",
          title: "Address where loss occurred"
        },
        insuredsection: {
          type: "string",
          title: "Section / Unit Number"
        },
        insureddateloss: {
          type: "string",
          title: "Date of Damages or Loss",
          format: "date-time"
        },
        insuredburstgeyser: {
          type: "string",
          title: "Burst Geyser",
          enum: ["Yes", "No"]
        },
        insuredgeysersize: {
          type: "string",
          title: "Size of Geyser",
          enum: ["50 Litre", "100 Litre", "150 Litre", "200 Litre", "300 Litre", "500 Litre", "Other"]
        },
        insuredgeyserrepair: {
          type: "string",
          title: "Geyser Maintenace",
          enum: ["50 Litre", "100 Litre", "200 Litre", "300 Litre", "500 Litre", "Other"]
        },
        insuredresultantdamages: {
          type: "array",
          title: "Resultant Damages",
          items: [{
            key: "floors",
            type: "boolean",
            title: "Floors"
          }, {
            key: "carpets",
            type: "boolean",
            title: "Carpets"
          }, {
            key: "ceilings",
            type: "boolean",
            title: "Ceilings"
          }, {
            key: "cupboards",
            type: "boolean",
            title: "Cupboards"
          }, {
            key: "other",
            type: "boolean",
            title: "Other"
          }]
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my / our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept terms and conditions",
          description: "Tick box to accept terms and conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  insuredaddress: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  }
};